export enum BarEditPageLoadReason {
    /** Regular load */
    Load,
    /** Load because a save happened */
    Save,
    /** Load after undo */
    Undo
}
